import { render, staticRenderFns } from "./SettingBet.vue?vue&type=template&id=b96905ae&scoped=true&"
import script from "./SettingBet.vue?vue&type=script&lang=js&"
export * from "./SettingBet.vue?vue&type=script&lang=js&"
import style0 from "./SettingBet.vue?vue&type=style&index=0&id=b96905ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96905ae",
  null
  
)

export default component.exports